import { format } from "date-fns";
import { ar, enUS } from "date-fns/locale";
import { useTranslation } from "react-i18next";

export const formatDueDate = (isoString: string | undefined, locale: string = "en", prefix: string = "Due") => {
  if (!isoString) return "";

  const dateLocale = locale === "ar" ? ar : enUS;
  try {
    return `${prefix} ${format(new Date(isoString), "d MMM yyyy - h:mm aa", { locale: dateLocale })}`;
  } catch (error) {
    return isoString;
  }
};

export const useFormatMilestoneDueDate = (isoString: string | undefined, prefix: string = "Due") => {
  const { i18n } = useTranslation();
  const locale = i18n.language === "ar" ? ar : enUS;

  if (!isoString) return "";

  try {
    return `${prefix} ${format(new Date(isoString), "d MMM yyyy - h:mm aa", { locale })}`;
  } catch (error) {
    return isoString;
  }
};
